import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { SdfButton, SdfIcon } from '@waypoint/react-components';

function AltErrorPage(props) {
  const { redirectToHome } = props;

  const primaryButton = {
    id: 'signin.close',
    description: 'Close',
    className: 'w-full max-w-xs md:min-w-32 md:w-auto mt-8 place-items-end',
    labelId: 'signin.close',
    defaultMessage: 'Close',
    clickFunction: redirectToHome,
  };

  return (
    <div>
      <div className="text-xl mb-8 mt-5">
        <FormattedMessage
          id="stepup.push.failure.subtext"
          defaultMessage="We weren't able to authenticate your account. You'll need to start again"
        />
      </div>

      <div className="text-center md:grid md:justify-end mt-6">
        <SdfButton
          buttonStyle="link"
          emphasis="primary"
          data-testid={ primaryButton.id }
          id={ primaryButton.id }
          className={ primaryButton.className }
          size="lg"
          onClick={ primaryButton.clickFunction }
        >
          <span>
            <FormattedMessage
              id={ primaryButton.labelId }
              defaultMessage={ primaryButton.defaultMessage }
              description={ primaryButton.description }
            />
          </span>
        </SdfButton>
      </div>
    </div>
  );
}

AltErrorPage.propTypes = {
  background: PropTypes.shape({
    default: PropTypes.string.isRequired,
  }),
  errorPageProps: PropTypes.shape({
    promoBoxRef: PropTypes.string,
    arialabel: PropTypes.string,
    linkRef: PropTypes.string,
    isButtonCheck: PropTypes.bool,
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
  redirectToHome: PropTypes.func.isRequired,
};

export default injectIntl(AltErrorPage);
